import * as React from "react";
import {
  ImageField,
  TextInput,
  ImageInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  NumberInput,
  useRecordContext,
  Title,
} from "react-admin";

import { SimpleForm } from "../common/SimpleForm";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import {
  validateMealTimes,
  validateOrder,
  validateRequired,
} from "../utils/Validations";
import LimitedArrayInput from "./components/LimitedArrayInput";

const PlaceTypeTitle = () => {
  const record = useRecordContext();
  return <Title title={`Tipo de Lugar "${record?.name}"`} />;
};

const PlaceTypeEdit = () => (
  <Edit title={<PlaceTypeTitle />} mutationMode="pessimistic" redirect="list">
    <SimpleForm>
      <TextInput source="name" label="Nombre" validate={validateRequired} />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [],
        }}
        validate={validateRequired}
        maxSize={IMAGE_MAX_SIZE}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (!formData?.image?.rawFile) {
            return <ImageField source="image" {...rest} />;
          }
        }}
      </FormDataConsumer>
      <LimitedArrayInput
        validate={validateMealTimes}
        source="mealTimes"
        label="Momentos ideales (ordenados por prioridad)"
      />
      <NumberInput
        source="order"
        label="Orden"
        min={1}
        validate={validateOrder}
        onWheel={(e) => e.target.blur()}
      />
      <TextInput
        source="iconName"
        label="Nombre de Ícono"
        validate={validateRequired}
      />
      <BooleanInput source="visible" label="Visible" />
      <BooleanInput source="active" label="Activo" />
    </SimpleForm>
  </Edit>
);

export default PlaceTypeEdit;
